var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "hidden-print" }, [
    _c("div", { staticClass: "container flush-outside" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _c("h5", [_c("strong", [_vm._v(_vm._s(_vm.$t("questions")))])]),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n          " + _vm._s(_vm.$t("contact_us"))),
            _c("br"),
            _vm._v("\n          " + _vm._s(_vm.$t("opening_hours"))),
            _c("br"),
            _vm._v("\n          " + _vm._s(_vm.$t("tel")) + " "),
            _c("a", { attrs: { href: "tel:+4922194714567" } }, [
              _vm._v("+49 221 94714-567")
            ]),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://www.gs1-germany.de/hilfe-faq/kontaktformular/?tx_gs1form_contactform%5btopic%5d=28",
                  target: "_blank",
                  rel: "noopener"
                }
              },
              [_vm._v(_vm._s(_vm.$t("contact_gs1")))]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 footer-links" },
          [
            _c("hr"),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.gs1-germany.de/",
                  target: "_blank",
                  rel: "noopener"
                }
              },
              [_vm._v(_vm._s(_vm.$t("links.gs1_germany")))]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "link-pipe" }, [_vm._v("|")]),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.gs1-germany.de/newsletter/",
                  target: "_blank",
                  rel: "noopener"
                }
              },
              [_vm._v(_vm._s(_vm.$t("links.newsletter")))]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "link-pipe" }, [_vm._v("|")]),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.gs1-germany.de/impressum/",
                  target: "_blank",
                  rel: "noopener"
                }
              },
              [_vm._v(_vm._s(_vm.$t("links.imprint")))]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "link-pipe" }, [_vm._v("|")]),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.gs1-germany.de/datenschutz/",
                  target: "_blank",
                  rel: "noopener"
                }
              },
              [_vm._v(_vm._s(_vm.$t("links.privacy")))]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "link-pipe" }, [_vm._v("|")]),
            _vm._v(" "),
            _c("router-link", { attrs: { to: { name: "TermsOfUse" } } }, [
              _vm._v(_vm._s(_vm.$t("links.terms_of_use")))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "link-pipe" }, [_vm._v("|")])
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40ab164b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40ab164b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 